import(/* webpackMode: "eager" */ "/app/app/[locale]/products/portfolio/page.tsx");
